import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

import { AuthPromoPanel } from './AuthPromoPanel'

export function AuthModeToggle({ mode }) {
  const isSignIn = mode === 'signin'
  return (
    <div className="auth-split__toggle" role="tablist" aria-label="Tipo de acesso">
      <Link
        to="/login"
        role="tab"
        aria-selected={isSignIn}
        className={`auth-split__toggle-btn${isSignIn ? ' is-active' : ''}`}
      >
        Entrar
      </Link>
      <Link
        to="/register"
        role="tab"
        aria-selected={!isSignIn}
        className={`auth-split__toggle-btn${!isSignIn ? ' is-active' : ''}`}
      >
        Criar conta
      </Link>
    </div>
  )
}

AuthModeToggle.propTypes = {
  mode: PropTypes.oneOf(['signin', 'signup']).isRequired
}

export function AuthSplitShell({
  mode,
  title,
  subtitle,
  children,
  wideLeft = false
}) {
  return (
    <div className="auth-split">
      <div className="auth-split__bg" aria-hidden />
      <div className="auth-split__layout">
        <div
          className={`auth-split__left${wideLeft ? ' auth-split__left--wide' : ''}`}
        >
          <Link to="/" className="auth-split__brand text-decoration-none">
            <span className="auth-split__brand-icon" aria-hidden>
              Z+
            </span>
            <span className="auth-split__brand-name">Zap+</span>
          </Link>

          <h1 className="auth-split__title">{title}</h1>
          {subtitle ? <p className="auth-split__lead">{subtitle}</p> : null}

          <AuthModeToggle mode={mode} />

          <div className="auth-split__form-slot">{children}</div>
        </div>

        <div className="auth-split__right">
          <AuthPromoPanel />
        </div>
      </div>
    </div>
  )
}

AuthSplitShell.propTypes = {
  mode: PropTypes.oneOf(['signin', 'signup']).isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node.isRequired,
  wideLeft: PropTypes.bool
}
